import { LineItem } from '../types/cash-register/cart-types';

export const calculateCartTotal = (lineItems: LineItem[]) => {
  return lineItems
    .filter(lineItem => !lineItem._destroy)
    .reduce((total, lineItem) => {
      return total + lineItem.total_price;
    }, 0);
};
